/* =============================================================================
 * LA URL DE LA TIENDA, CON LA CAMPAÑA PUESTA — Y AL DÍA.
 * -----------------------------------------------------------------------------
 * `withCampaign` es una función pura: devuelve lo que hubiera en el almacén EN EL INSTANTE en que
 * se la llama. El botón de entradas la llamaba al pintar, y ahí está el problema: la campaña se
 * captura en un efecto, que corre DESPUÉS del primer pintado.
 *
 * Para quien navega por dentro del sitio no se nota —la campaña ya venía guardada de la pantalla
 * anterior—, pero quien aterriza directo desde un anuncio pinta el botón con el almacén vacío y se
 * queda con el enlace pelado: nada vuelve a repintarlo. Justo el visitante que costó dinero.
 *
 * Medido en producción el 12-ago-2026 con `?utm_source=meta&fbclid=…`:
 *   · directo a `/buenos-aires` → enlace SIN campaña
 *   · a `/` y luego a la ciudad → enlace CON campaña
 *
 * `useSyncExternalStore` es exactamente la herramienta: un valor que vive fuera de React y del que
 * hay que enterarse cuando cambia. Se suscribe a `onCampaignChange`, que avisa cuando la captura
 * guarda algo nuevo — al montar (los `utm_*`) y al aceptar el banner (los identificadores de clic,
 * que esperan al sí por RGPD).
 * ========================================================================== */
import { useSyncExternalStore } from 'react';

import { onCampaignChange, withCampaign } from './campaign';

export function useCampaignUrl(url: string): string {
  return useSyncExternalStore(
    onCampaignChange,
    () => withCampaign(url),
    // En el servidor no hay ni URL de aterrizaje ni almacén: la URL va limpia y el cliente la
    // recalcula al hidratar. Devolver otra cosa aquí sería inventarse una atribución.
    () => url,
  );
}
